import { render, staticRenderFns } from "./profiles-form.vue?vue&type=template&id=72015d7a&scoped=true&lang=pug&"
import script from "./profiles-form.vue?vue&type=script&lang=ts&"
export * from "./profiles-form.vue?vue&type=script&lang=ts&"
import style0 from "./profiles-form.vue?vue&type=style&index=0&id=72015d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72015d7a",
  null
  
)

export default component.exports